import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 3AD46D54-4369-483C-A0B5-E03D7CF62F3B
 * name gamepad-round
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round.svg
 * tags
 * - Gaming / RPG 
 */
export const GamepadRoundIcon = createSvgIcon(<><path d="M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8Z" /></>, 'GamepadRoundIcon');
export default GamepadRoundIcon